<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button routerDirection="root" routerLink="/tabs">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center">{{ 'gyms-page.your-gyms' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-list *ngIf="gyms?.length>0 || activeGym else loading">
    <ion-item (press)="gymPressed(activeGym)" data-cy="active-gym-button" *ngIf="activeGym" class="active-gym" [routerLink]="activeGym.gymId" button
              detail>
      {{activeGym.gymName}}
      <ion-note slot="end"><b>{{ 'gyms-page.active' | translate }}</b>
      </ion-note>
    </ion-item>
    <ion-item (press)="gymPressed(gym)" [routerLink]="gym.gymId" *ngFor="let gym of gyms" button detail>
      {{gym.gymName}}
      <ion-note slot="end">{{gym.city}}
      </ion-note>
    </ion-item>
  </ion-list>
  <br>
  <ion-button [routerLink]="'/download-gym'" routerDirection="root" data-cy="search-gym">
    <ion-icon name="list" slot="start"></ion-icon>
    {{"gyms-page.search-gym" | translate}}
  </ion-button>
</ion-content>
<ng-template #loading>
  <logo></logo>
  <br><br>
  <h1>{{"gyms-page.welcome-to-boulderbook" | translate}}</h1>
  <p>{{"gyms-page.find-your-gym" | translate}}</p>
</ng-template>
